export const pdvItems = { category: "pdv", key: "pdv", name: "PDV" };
